import Icon from "@ant-design/icons";

const SearchIconSVG = (props) => (
  <svg
    width="1.25em"
    height="1.25em"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.58317 18.1251C4.87484 18.1251 1.0415 14.2917 1.0415 9.58341C1.0415 4.87508 4.87484 1.04175 9.58317 1.04175C14.2915 1.04175 18.1248 4.87508 18.1248 9.58341C18.1248 14.2917 14.2915 18.1251 9.58317 18.1251ZM9.58317 2.29175C5.55817 2.29175 2.2915 5.56675 2.2915 9.58341C2.2915 13.6001 5.55817 16.8751 9.58317 16.8751C13.6082 16.8751 16.8748 13.6001 16.8748 9.58341C16.8748 5.56675 13.6082 2.29175 9.58317 2.29175Z"
      fill="#9A8EA4"
    />
    <path
      d="M18.3335 18.9583C18.1752 18.9583 18.0169 18.9 17.8919 18.775L16.2252 17.1083C15.9835 16.8666 15.9835 16.4666 16.2252 16.225C16.4669 15.9833 16.8669 15.9833 17.1085 16.225L18.7752 17.8916C19.0169 18.1333 19.0169 18.5333 18.7752 18.775C18.6502 18.9 18.4919 18.9583 18.3335 18.9583Z"
      fill="#9A8EA4"
    />
  </svg>
);
const SearchIcon = (props) => (
  <Icon component={() => SearchIconSVG(props)} {...props} />
);

export default SearchIcon;
